import { ref, onMounted } from 'vue';

export default function (props?: { delay?: number; rootMargin?: string; threshold?: number }) {
	let observer: IntersectionObserver;

	const animatedCardsRefs = ref<(Element | ComponentPublicInstance | null)[]>([]);
	const isVisible = ref(Array(animatedCardsRefs.value.length).fill(false));

	onMounted(() => {
		initIntersectionObserver();
	});

	onUnmounted(() => {
		if (observer) {
			observer.disconnect();
		}
	});

	function initIntersectionObserver() {
		const options = {
			root: null,
			rootMargin: props?.rootMargin || '100px',
			threshold: props?.threshold || 0.1,
		};
		observer = new IntersectionObserver((entries) => {
			let stepDelay = 0;
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					const index = animatedCardsRefs.value.indexOf(entry.target as HTMLElement);
					if (index !== -1 && !isVisible.value[index]) {
						setTimeout(() => {
							isVisible.value[index] = true;
						}, stepDelay);
						stepDelay += props?.delay || 100;
						observer.unobserve(entry.target);
					}
				}
			});
		}, options);
		animatedCardsRefs.value.forEach((section: Element | ComponentPublicInstance | null) => {
			if (section instanceof Element) {
				observer.observe(section);
			}
		});
	}

	return { isVisible: readonly(isVisible), animatedCardsRefs };
}
